export default {
  NAVLIST: [
    { mark: 'home', name: '首 页', nameEN: 'Homepage', path: '/home' },
    { mark: 'public', name: '公开课', nameEN: 'Public Class', path: '/public' },
    { mark: 'pbl',
      name: '推荐信PBL',
      nameEN: 'PBL',
      path: '/coursepbl',
      children: [
        { mark: 'highschool', name: '高中PBL', nameEN: 'High School', path: '/highschool', img: require('./images/highschool.png') },
        { mark: 'collage', name: '大学PBL', nameEN: 'College', path: '/college', img: require('./images/collage.png') },
        { mark: 'onevone', name: '1v1课程', nameEN: '1v1 Class', path: '/onevone', img: require('./images/m1v1.png') },
        { mark: 'aihub', name: 'AI HUB', nameEN: 'AI HUB', path: '/aihub', img: require('./images/aihub.png') }
      ]
    },
    {
      mark: 'international',
      name: '国际学校',
      nameEN: 'School',
      path: '/international',
      children: [
        { mark: 'intlschool', name: '国际高中', nameEN: 'Intl School', path: '/intlschool', img: require('./images/intlschool.png') },
        { mark: 'plan', name: '1636计划', nameEN: '1636 Plan', path: '/plan', img: require('./images/plan.png') },
        { mark: 'club', name: '优+家长俱乐部', nameEN: 'Elite+ Club', path: '/club', img: require('./images/club.png') }
      ]
    },
    { mark: 'stucase', name: '学员案例', nameEN: 'Student Cases', path: '/case' },
    { mark: 'about', name: '关于我们', nameEN: 'About Us', path: '/about' }
  ]
}



// WEBPACK FOOTER //
// ./src/components/gecHeaderNew/config.js